import { useEffect, useState } from "react";
import { Modal, Box, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CardAmostra from "./CardAmostra";
import formatarHora from "./formatarHora";
import "./styles.css";

export default function ConteudoMapa({
  cards = [],
  loading = false,
  onConfirmarRemocao,
}) {

  const [tempoAgora, setTempoAgora] = useState(() => new Date());
  const [modalRemoverOpen, setModalRemoverOpen] = useState(false);
  const [amostraRemover, setAmostraRemover] = useState(null);
  const [processandoRemocao, setProcessandoRemocao] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => setTempoAgora(new Date()), 15000);
    return () => clearInterval(interval);
  }, []);

  function handleAbrirModalRemover(amostra) {
    setAmostraRemover(amostra);
    setModalRemoverOpen(true);
  }

  function handleFecharModalRemover() {
    setModalRemoverOpen(false);
    setAmostraRemover(null);
    setProcessandoRemocao(false);
  }

  async function handleConfirmarRemocao() {
    if (processandoRemocao || !amostraRemover) return;
    setProcessandoRemocao(true);
    try {
      await onConfirmarRemocao(amostraRemover.id);
      handleFecharModalRemover();
    } finally {
      setProcessandoRemocao(false);
    }
  }

  return (
    <div className="conteudo-mapa-trace">
      {loading ? (
        <div className="mensagem-vazia">Carregando cards...</div>
      ) : (
        <>
          {cards.length === 0 ? (
            <div className="mensagem-vazia">
              Nenhum card encontrado para os filtros selecionados.
            </div>
          ) : (
            <div className="mapa-trace-cards">
              {cards.map((amostra) => (
                <CardAmostra
                  key={amostra.id}
                  amostra={amostra}
                  tempoAgora={tempoAgora}
                  onRemoverClick={handleAbrirModalRemover}
                />
              ))}
            </div>
          )}
          <p className="conteudo-mapa-trace-aviso">
            Clique em qualquer card ativo para confirmar a retirada do tubo.
          </p>
        </>
      )}

      <Modal
        open={modalRemoverOpen}
        onClose={handleFecharModalRemover}
        aria-labelledby="modal-remover-banho-title"
      >
        <Box className="modal-remover-banho">
          <h2
            className="modal-remover-banho-title"
            id="modal-remover-banho-title"
          >
            Confirmar retirada do banho
            <IconButton
              aria-label="Fechar"
              onClick={handleFecharModalRemover}
              sx={{ float: "right", marginTop: "-8px" }}
            >
              <CloseIcon />
            </IconButton>
          </h2>
          {amostraRemover && (
            <>
              <p className="modal-remover-banho-pergunta">
                Tem certeza que deseja remover este tubo do banho?
              </p>
              <p className="modal-remover-banho-tubo-esperado">
                <strong>Código da amostra:</strong>{" "}
                {amostraRemover.biomeriuex || "—"}
                <br />
                <strong>Código do tubo:</strong> {amostraRemover.codigoTubo || "—"}
                <br />
                <strong>Hora prevista:</strong>{" "}
                {amostraRemover.previstoRemocaoEm
                  ? formatarHora(amostraRemover.previstoRemocaoEm)
                  : "—"}
              </p>
              <div className="modal-remover-banho-acoes">
                <Button
                  variant="outlined"
                  onClick={handleFecharModalRemover}
                  disabled={processandoRemocao}
                >
                  Não
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirmarRemocao}
                  disabled={processandoRemocao}
                >
                  {processandoRemocao ? "Confirmando..." : "Sim"}
                </Button>
              </div>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}
